(function() {
  if (!window.filterMenuState) {
    window.filterMenuState = {
      currentObserver: null,
      resizeTimer: null
    };
  }

  function checkOverflow(navElement) {
    if (!navElement) return;
    const hasOverflow = navElement.scrollWidth > navElement.clientWidth;
    if (hasOverflow) {
      navElement.classList.add('has-overflow');
    } else {
      navElement.classList.remove('has-overflow');
    }
  }

  function isMobile() {
    return window.innerWidth <= 749;
  }

  function initializeFilterMenu() {
    const filterMenuSection = document.querySelector('[data-filter-menu-original]');
    const filterMenuSticky = document.querySelector('[data-filter-menu-sticky]');
    const filterMenuNav = filterMenuSection ? filterMenuSection.querySelector('.filter-menu-nav') : null;
    const filterMenuNavSticky = filterMenuSticky ? filterMenuSticky.querySelector('.filter-menu-nav') : null;

    if (!filterMenuNav) return;

    if (window.filterMenuState.currentObserver && filterMenuSection) {
      window.filterMenuState.currentObserver.unobserve(filterMenuSection);
      window.filterMenuState.currentObserver.disconnect();
      window.filterMenuState.currentObserver = null;
    }

    function updateStickyMenu() {
      if (!filterMenuNavSticky) return;
      checkOverflow(filterMenuNavSticky);
    }

    function initStickyBar() {
      if (!filterMenuSection || !filterMenuSticky) return;

      if (!isMobile()) {
        filterMenuSticky.style.display = 'none';
        filterMenuSticky.classList.remove('is-visible');
        return;
      }

      const observer = new IntersectionObserver(function(entries) {
        if (!isMobile()) {
          filterMenuSticky.style.display = 'none';
          filterMenuSticky.classList.remove('is-visible');
          return;
        }

        entries.forEach(function(entry) {
          if (!entry.isIntersecting) {
            filterMenuSticky.style.display = 'block';
            filterMenuSticky.classList.add('is-visible');
            updateStickyMenu();
          } else {
            filterMenuSticky.style.display = 'none';
            filterMenuSticky.classList.remove('is-visible');
          }
        });
      }, {
        threshold: 0,
        rootMargin: '0px'
      });

      window.filterMenuState.currentObserver = observer;
      observer.observe(filterMenuSection);
    }

    function initialize() {
      checkOverflow(filterMenuNav);
      if (filterMenuNavSticky) {
        checkOverflow(filterMenuNavSticky);
      }
      initStickyBar();
    }

    initialize();
  }

  window.initializeFilterMenu = initializeFilterMenu;

  if (!window.filterMenuResizeListener) {
    window.filterMenuResizeListener = function() {
      clearTimeout(window.filterMenuState.resizeTimer);
      window.filterMenuState.resizeTimer = setTimeout(function() {
        initializeFilterMenu();
      }, 100);
    };
    window.addEventListener('resize', window.filterMenuResizeListener);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeFilterMenu);
  } else {
    initializeFilterMenu();
  }

  setTimeout(initializeFilterMenu, 100);
})();

